import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class DayOfService {
	url = '/api/v1/ez/sessions';
	log$ = new BehaviorSubject<string>('');

	constructor(private http: HttpClient) {}

	ping(eventId) {
		return this.http
			.get<{ history: string; admin: boolean }>(
				`/api/event/${eventId}/ping`
			)
			.pipe(tap((res) => this.log$.next(res.history)));
	}

	getEventStats(eventId) {
		return this.http.get<{ need_weighin: number; need_checkin: number }>(
			`/api/event/${eventId}/eventstats`
		);
	}

	login(eventId, payload: { user: string; pass: string }) {
		return this.http.post(`/api/event/${eventId}/login`, payload);
	}

	logout(eventId) {
		return this.http.post(`/api/event/${eventId}/logout`, null);
	}

	checkinSearch(
		eventId,
		payload: {
			name_first: string;
			name_last: string;
			member_usat: string;
		}
	) {
		return this.http.post(`/api/event/${eventId}/checkin/search`, payload);
	}

	weighInSearch(
		eventId,
		payload: {
			name_first: string;
			name_last: string;
			id: string;
		}
	) {
		return this.http.post(
			`/api/v1/ez/events/${eventId}/weighin/search`,
			payload
		);
	}

	getChecklist(eventId, member_id, member_type) {
		return this.http.get(`/api/event/${eventId}/checkin/checklist`, {
			params: new HttpParams()
				.set('member_id', member_id)
				.set('member_type', member_type),
		});
	}

	recordChecklist(eventId, member_id, member_type, checklist_id, data?) {
		return this.http
			.post(`/api/event/${eventId}/checkin/record`, {
				member_id: member_id,
				member_type: member_type,
				checklist_id: checklist_id,
				data: data,
			})
			.pipe(tap(() => this.ping(eventId).subscribe()));
	}

	getWeighInDivisions(eventId, member_id, member_weight, division_id) {
		return this.http.get(`/api/v1/ez/events/${eventId}/weighin/divisions`, {
			params: new HttpParams()
				.set('member_id', member_id)
				.set('member_weight', member_weight)
				.set('division_id', division_id),
		});
	}

	recordWeight(eventId, member_id, division_id, member_weight) {
		// For debugging
		// return of({
		// 	status: 'RETRY',
		// 	division: {
		// 		id: '3013',
		// 		name: 'World Class Sparring Bantam :: 37.00 - 41.00 :: 12 - 14 :: M',
		// 	},
		// 	weight_ok: false,
		// 	html: 'John NOBLE weight of 32kg is NOT OK and will be rebracketed on second attempt',
		// 	history: '',
		// });
		return this.http.post(`/api/v1/ez/events/${eventId}/weighin/record`, {
			member_id,
			division_id,
			member_weight,
		});
	}

	getDivisionResults(eventId, divisionId) {
		return this.http.get<{
			competitors: {
				id: string;
				name_first: string;
				name_last: string;
				name_middle: string;
				member_usat: string;
			}[];
			type: 'BRACKET' | 'LIST' | 'LIST+SCORE';
			recorded: boolean;
			name: string;
		}>(`/api/event/${eventId}/results/divisions/${divisionId}`);
	}

	recordDivisionResults(eventId, divisionId, payload) {
		return this.http.post(
			`/api/event/${eventId}/results/record/${divisionId}`,
			payload
		);
	}

	downloadResults(eventId) {
		window.open(`/api/event/${eventId}/results/export`);
	}
}
